/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import React from 'react';

const SvgIconBotSad = props => {
  return (
    <svg viewBox="0 0 334 297" {...props} role="img" aria-hidden="true" focusable="false">
      <g fill="none" fillRule="evenodd">
        <circle cx={198} cy={136.667} r={136} fill="#F2F2F2" />
        <path
          fill="#A03738"
          d="M68.351 269.832h84.583c2.294 0 3.126.239 3.965.687a4.678 4.678 0 011.945 1.946c.449.838.687 1.67.687 3.964v12.525c0 2.294-.238 3.126-.687 3.965a4.676 4.676 0 01-1.945 1.945c-.839.449-1.67.688-3.965.688H68.351c-2.294 0-3.126-.24-3.964-.688a4.678 4.678 0 01-1.946-1.945c-.448-.839-.687-1.67-.687-3.965V276.43c0-2.294.239-3.126.687-3.964a4.675 4.675 0 011.946-1.946c.838-.448 1.67-.687 3.964-.687z"
        />
        <g transform="translate(78.193 32.34)">
          <path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={7.565}
            d="M65.9 26.59L19.585 6.016l5.046 45.284"
          />
          <ellipse cx={71.046} cy={26.591} fill="#000" rx={20.585} ry={20.576} />
          <ellipse cx={71.046} cy={26.591} fill="#EF6461" rx={10.292} ry={10.288} />
        </g>
        <path
          fill="#EF6461"
          d="M100.307 79.506h15.526c55.398 0 100.306 44.91 100.306 100.307v69.43c0 17.053-13.824 30.877-30.877 30.877H30.877C13.824 280.12 0 266.296 0 249.243v-69.43C0 124.415 44.909 79.506 100.307 79.506z"
        />
        <path
          fill="#FFF"
          d="M92.631 213.249c7.862 1.008 14.938 1.513 21.228 1.513 6.29 0 18.083-.505 35.38-1.513v66.87H92.631v-66.87z"
        />
        <path
          fill="#943E3C"
          d="M110.599 79.506c-55.398 0-100.307 44.91-100.307 100.307v69.43c0 17.053 13.824 30.877 30.877 30.877H30.877C13.824 280.12 0 266.296 0 249.243v-69.43C0 124.415 44.909 79.506 100.307 79.506z"
        />
        <g transform="translate(61.754 127.8)">
          <path
            fill="#FFF"
            d="M112.382 74.55c0-17.867-6.37-33.34-21.486-37.801-13.904-4.103-21.36-6.201-34.288-6.201-10.27 0-16.883.74-28.156 2.04C7.205 35.038.834 54.026.834 74.549c0 30.79 111.548 30.79 111.548 0z"
          />
          <path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={18.526}
            d="M27.288 1.86c10.728 13.333 24.819 24.624 41.704 32.495 17.59 8.198 36.075 11.689 53.848 10.981"
          />
          <path
            fill="#000"
            d="M50.433 90.592c17.052 0 37.052-1.017 37.052-12.786 0-6.765-4.569-12.795-11.694-16.698-5.268-2.886-11.934-.349-19.183-.349-9.332 0-17.697-1.404-23.36 3.111-4.683 3.737-7.517 8.608-7.517 13.936 0 11.769 7.649 12.786 24.702 12.786z"
          />
          <ellipse cx={75.134} cy={65.901} fill="#FFF" rx={12.351} ry={12.345} />
          <ellipse cx={81.31} cy={84.419} fill="#FFF" rx={6.175} ry={6.173} />
        </g>
      </g>
    </svg>
  );
};

export default SvgIconBotSad;
